import React from 'react';

const FitToPageIcon = props => (
  <svg viewBox="0 0 14 18" {...props}>
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <rect opacity="0.6" x="0" y="16" width="14" height="2"/>
      <rect opacity="0.6" x="0" y="0" width="14" height="2"/>
      <rect x="0" y="4" width="14" height="10"/>
    </g>
  </svg>
);

export default FitToPageIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/fit-to-page-icon.js